export default "__VITE_ASSET__DtwynrQH__"